import { render, staticRenderFns } from "./TaxonomyChildren.vue?vue&type=template&id=3eea3d16&"
import script from "./TaxonomyChildren.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyChildren.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports